import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { litIf } from "../LitUtils";
import { formatDistance } from "../../Format";

@customElement("ds-distance")
export class Distance extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }
        `,
    ];
    @property({ type: Number }) distance?: number;
    @property({ type: Boolean }) autoUnits = false;
    @property({ type: Number }) decimals = 0;

    private _format(distance?: number) {
        if (!distance) {
            return "";
        }
        return formatDistance(distance, this.decimals, this.autoUnits);
    }

    override render() {
        return litIf(
            !!this.distance,
            () => html`<span>${this._format(this.distance as number)}</span>`
        );
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-distance": Distance;
    }
}
